import React, { useState, useEffect } from "react";

import {
  TextField,
  Alert,
  Tooltip,
  Dialog,
  DialogActions,
  DialogTitle,
  DialogContent,
  DialogContentText,
  Button,
  Select as MSelect,
  MenuItem,
} from "@mui/material";
import { Update, Delete } from "@mui/icons-material";
import Select, { components } from "react-select";

import axios from "axios";

const CustomOption = (props) => {
  return (
    <Tooltip
      title="color"
      placement="left"
      PopperProps={{
        style: { zIndex: 10001 },
        modifiers: [
          {
            name: "offset",
            options: {
              offset: [0, -10],
            },
          },
        ],
        sx: {
          "& .MuiTooltip-tooltip": {
            fontSize: "14px",
            backgroundColor: `${props.data.tooltip}`,
            color: ` ${props.data.tooltip}`,
          },
        },
      }}
    >
      <div>
        <components.Option {...props} />
      </div>
    </Tooltip>
  );
};

const DeleteDialog = (props) => {
  const [selectedCategory, setSelectedCategory] = useState("");

  const handleCategoryDelete = async (e) => {
    e.preventDefault();
    props.setError("");
    props.setSuccess("");

    // Add your API call here to delete the category
    // console.log(`Bearer ${props.user.token.toString()}`);
    try {
      const response = await axios.delete(
        `http://localhost:8080/action-option/deleteActionOption/${props.selectedCategory}`,
        {
          replacementId: selectedCategory,
          headers: {
            Authorization: `Bearer ${props.user.token}`,
          },
        }
      );

      props.setCategories(
        props.categories.filter((category) => category._id !== props.selectedCategory)
      );

      props.setSuccess("Ενέργεια διαγράφηκε επιτυχώς.");
      props.onClose();
    } catch (error) {
      console.log(error);
      props.setError("Αποτυχία διαγραφής Δραστηριότητας. Παρακαλώ δοκιμάστε ξανά.");
      props.onClose();
    }
  };

  return (
    <Dialog
      open={props.open}
      onClose={props.onClose}
      aria-labelledby="alert-dialog-title"
      aria-describedby="alert-dialog-description"
    >
      <DialogTitle id="alert-dialog-title">{"Διαγραγή Δραστηριότητας"}</DialogTitle>
      <DialogContent>
        <DialogContentText id="alert-dialog-description">
          Διάλεξε την δραστηριότητα που θέλεις να αντικαταστήσεις την τρέχουσα.
        </DialogContentText>

        <MSelect
          value={selectedCategory}
          onChange={(e) => setSelectedCategory(e.target.value)}
          fullWidth
          sx={{
            width: "100%",
          }}
        >
          {props.categories
            .filter((category) => category._id !== props.selectedCategory)
            .map((category) => (
              <MenuItem key={category._id} value={category._id}>
                {category.name}
              </MenuItem>
            ))}
        </MSelect>
      </DialogContent>
      <DialogActions>
        <Button onClick={props.onClose}>ΑΚΥΡΩΣΗ</Button>
        <Button
          onClick={handleCategoryDelete}
          autoFocus
          disabled={selectedCategory === ""}
        >
          ΔΙΑΓΡΑΦΗ
        </Button>
      </DialogActions>
    </Dialog>
  );
};

const UpdateActionOption = () => {
  const [categoryName, setCategoryName] = useState("");
  const [categoryColor, setCategoryColor] = useState("#FA0808");
  const [error, setError] = useState("");
  const [success, setSuccess] = useState("");
  const [categories, setCategories] = useState([]);
  const [selectedCategory, setSelectedCategory] = useState("");
  const [deleteDialogOpen, setDeleteDialogOpen] = useState(false);

  const user = JSON.parse(localStorage.getItem("user"));

  useEffect(() => {
    const fetchCategories = async () => {
      try {
        const response = await axios.get(
          "http://localhost:8080/action-option/getActionOptions",
          {
            headers: {
              Authorization: `Bearer ${user.token}`,
            },
          }
        );
        setCategories(response.data.actionOptions);
      } catch (error) {
        setError("Failed to fetch categories. Please try again.");
      }
    };
    fetchCategories();
  }, []);

  const handleCategorySelect = (selectedOption) => {
    setSelectedCategory(selectedOption.value);
    setCategoryName(selectedOption.label);
    setCategoryColor(selectedOption.tooltip);
  };

  const handleUpdateCategory = async (e) => {
    e.preventDefault();
    setError("");
    setSuccess("");

    if (categoryName === "") {
      return setError("Το όνομα της Δραστηριότητας είναι υποχρεωτικό.");
    }

    // Add your API call here to update the category
    try {
      const response = await axios.put(
        `http://localhost:8080/action-option/updateActionOption/${selectedCategory}`,
        {
          name: categoryName,
          color: categoryColor,
        },
        {
          headers: {
            Authorization: `Bearer ${user.token}`,
          },
        }
      );

      setCategories(
        [...categories].map((category) => {
          if (category._id === selectedCategory) {
            return {
              ...category,
              title: categoryName,
              color: categoryColor,
            };
          }
          return category;
        })
      );

      setSuccess("Επιτυχής ενημέρωση Δραστηριότητας.");
    } catch (error) {
      if (error.response && error.response.status === 409) {
        setError("Ενέργεια με αυτό το όνομα υπάρχει ήδη.");
      } else {
        setError("Αποτυχία ενημέρωσης Δραστηριότητας. Παρακαλώ δοκιμάστε ξανά.");
      }
    }
  };

  return (
    <div className="update-category-option-wrapper">
      {error && <Alert severity="error">{error}</Alert>}
      {success && <Alert severity="success">{success}</Alert>}
      <h4
        style={{
          marginBottom: "10px",
          fontWeight: "600",
        }}
      >
       Επεξεργασία Δραστηριότητας
      </h4>
      <Select
        value={selectedCategory.value}
        onChange={(selectedOption) => handleCategorySelect(selectedOption)}
        theme={(theme) => ({
          ...theme,
          colors: {
            ...theme.colors,
            primary: "var(--secondary-color)",
            primary25: "var(--tertiary-color)",
          },
        })}
        options={[
          ...categories.map((category) => ({
            value: category._id,
            label: category.name,
            tooltip: category.color,
          })),
        ]}
        components={{ Option: CustomOption }}
        styles={{
          menu: (base) => ({
            ...base,
            zIndex: 1000, // Adjust this value as needed, ensuring it is higher than the z-index of other components
          }),
        }}
      />

      {selectedCategory && (
        <div
          style={{
            display: "flex",
            flexDirection: "row",
            gap: "10px",
            width: "100%",
            alignItems: "center",
          }}
        >
          <form
            onSubmit={handleUpdateCategory}
            style={{
              display: "flex",
              flexDirection: "row",
              gap: "10px",
              width: "100%",
              alignItems: "center",
            }}
          >
            <TextField
              variant="outlined"
              label="Όνομα Δραστηριότητας"
              placeholder="Όνομα Δραστηριότητας"
              value={categoryName}
              onChange={(e) => setCategoryName(e.target.value)}
              fullWidth
              margin="normal"
              InputProps={{
                inputProps: { style: { height: "56px", padding: "5px" } }, // Adjust the style as needed
              }}
            />
            <TextField
              variant="outlined"
              type="color"
              label="Χρώμα Δραστηριότητας"
              value={categoryColor}
              onChange={(e) => setCategoryColor(e.target.value)}
              margin="normal"
              sx={{
                width: "20%",
              }}
              // Custom styling may be required for color input to look consistent
              InputProps={{
                inputProps: { style: { height: "56px", padding: "5px" } }, // Adjust the style as needed
              }}
            />
            <button
              className="add-ticket-button__button"
              sx={{
                backgroundColor: "var(--primary-color)",
                color: "var(--primary-text-color)",
                fontSize: "15px",
                fontWeight: "600",
                width: "auto",
                padding: "10px 20px",
              }}
              onClick={() => {}}
            >
              <Update />
              <span>ΕΝΗΜΕΡΩΣΗ</span>
            </button>
          </form>
          <button
            className="add-ticket-button__button"
            sx={{
              backgroundColor: "var(--primary-color)",
              color: "var(--primary-text-color)",
              fontSize: "15px",
              fontWeight: "600",
              width: "auto",
              padding: "0px 20px",
            }}
            onClick={() => setDeleteDialogOpen(true)}
          >
            <Delete />
            <span>ΔΙΑΓΡΑΦΗ</span>
          </button>
          <DeleteDialog
            open={deleteDialogOpen}
            onClose={() => setDeleteDialogOpen(false)}
            categories={categories}
            setCategories={setCategories}
            selectedCategory={selectedCategory}
            setError={setError}
            setSuccess={setSuccess}
            user={user}
          />
        </div>
      )}
    </div>
  );
};

export default UpdateActionOption;
